/**
 * Exact reproduction of the template's back-to-top button.
 * Visibility + click behaviour are handled by template-init.js via jQuery.
 */
export function BackToTop() {
  return (
    <button id="back-top" className="back-to-top" aria-label="back to top">
      <i className="fa-solid fa-chevron-up"></i>
    </button>
  )
}
